import axios, { RawAxiosRequestHeaders } from 'axios';

const baseContentDeliveryApiUrl = '/api/episerver/v2.0/content/';
const baseAjaxApiUrl = '/ajax/';

export const createContentDeliveryClient = (config?: {
	headers: RawAxiosRequestHeaders;
}) => {
	return axios.create({
		headers: {
			...config?.headers,
		},
		baseURL: baseContentDeliveryApiUrl,
		...config,
	});
};

export const createAjaxApiDeliveryClient = (config?: {
	headers: RawAxiosRequestHeaders;
}) => {
	return axios.create({
		headers: {
			...config?.headers,
		},
		baseURL: baseAjaxApiUrl,
		...config,
	});
};
